import { Step } from 'react-joyride';

const CompanyProfileTourSteps: Step[] = [
  {
    target: '.tour-title',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Bienvenido a la sección <strong>Perfil de la Empresa</strong>. Aquí
        podrás configurar toda la información general de tu negocio, desde el
        nombre y el logo, hasta el horario de atención.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-logo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Haz clic aquí para <strong>subir o cambiar el logo</strong> de tu
        empresa. Este logo se mostrará en la interfaz pública y en algunos
        documentos como el QR o citas.
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.tour-schedule-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Al pulsar aquí se abre una ventana donde puedes{' '}
        <strong>configurar el horario de atención</strong> semanal de tu
        empresa: define, día por día, las franjas horarias en las que estás
        disponible. Este horario es la base sobre la que se generan los
        huecos disponibles para que los clientes reserven.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-holiday-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí se abre una ventana para <strong>añadir días festivos</strong>, o cualquier fecha en
        la que tu empresa no atienda. Esos días quedarán bloqueados
        automáticamente para que nadie pueda reservar en ellos.
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-inputs',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí puedes <strong>editar los datos principales</strong> de tu empresa
        como el nombre, dirección, ciudad, teléfono, categoría y subcategorías
        o el email de contacto.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-ia-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Si no sabes qué escribir, pulsa aquí y la <strong>IA generará una
        descripción</strong> de tu negocio por ti. Podrás revisarla, regenerarla
        o aceptarla antes de guardar.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-save-btn',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Una vez hayas realizado cambios, haz clic aquí para{' '}
        <strong>guardarlos</strong> y actualizar tu perfil.
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.tour-social',
    content: (
      <div style={{ textAlign: 'justify' }}>
        En esta sección puedes{' '}
        <strong>añadir y gestionar las redes sociales</strong> de tu empresa.
        Los enlaces aparecerán en la vista pública para que los clientes puedan
        seguirte.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-add-photo',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Aquí puedes <strong>subir imágenes</strong> que se mostrarán en la
        página pública de tu negocio — hasta 10 fotos. Pasa el cursor sobre
        una foto y pulsa la <strong>estrella</strong> para marcarla como
        imagen principal, la primera que verán tus clientes.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-founder',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Como <strong>Fundador</strong>, aquí puedes consultar tus beneficios
        exclusivos: condiciones de precio de por vida, acceso prioritario a
        nuevas funciones y soporte directo con el equipo.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.tour-security',
    content: (
      <div style={{ textAlign: 'justify' }}>
        Desde aquí puedes <strong>cambiar tu contraseña</strong> y mantener la
        seguridad de la cuenta de tu empresa.
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
];

export default CompanyProfileTourSteps;